import { useState } from "react";
import { Chevron } from "./icons";

export interface QA {
  q: string;
  a: string;
}

export const FAQS: QA[] = [
  { q: "How fast is my server ready?", a: "Minutes. We provision a dedicated node, install the game, open the ports and run a healthcheck while you watch it happen live — then hand you a link to share." },
  { q: "Which games can I host?", a: "A huge, ever-growing library — Minecraft, Valheim, Rust, Palworld, ARK, CS2, Terraria, Project Zomboid, Satisfactory and 20+ more across survival, sandbox, shooters and co-op. Don't see yours? Request it and we'll prioritize it." },
  { q: "Do I need any technical know-how?", a: "None at all. There's no control panel maze, no SSH, no config files. If you can pick a game from a list, you can run a server." },
  { q: "What happens when I cancel?", a: "Your server keeps running until the end of your billing period, then we take a final backup and keep it safe for a while in case you come back. No lock-in, ever." },
  { q: "Will my worlds be safe?", a: "Yes. Backups run quietly on autopilot, so one rough night can never wipe out the saga. You can also snapshot on demand and roll back from the dashboard." },
  { q: "Where are servers hosted?", a: "We place your server close to your crew for the lowest latency, and we're expanding regions fast as more players come online." },
];

export function Faq({ items = FAQS }: { items?: QA[] }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="faq" data-testid="faq">
      {items.map((item, i) => (
        <div className="faq-item" key={item.q} data-open={open === i}>
          <button
            className="faq-q"
            aria-expanded={open === i}
            onClick={() => setOpen(open === i ? null : i)}
          >
            {item.q}
            <span className="chev"><Chevron /></span>
          </button>
          <div className="faq-a">
            <div>{item.a}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
